export const packages = [
    {
        name: "AUDIENCE",
        id: 1,
        features: [
            "define",
            "manuel",
            "predefined",
            "manuel::time_range",
            "manuel::os_type",
            "manuel::profile",
            "manuel::activity",
            "manuel::gender",
            "manuel::generation",
            "manuel::app",
            "manuel::location",
            "manuel::user_status",
            "manuel::product_analytic",
            "manuel::product_prediction",
            "analytic::sales_prediction"
        ]
    },
    {
        name: "USER_ANALYTIC",
        id: 2,
        features: [
            "filter",
            "filter::profile",
            "filter::purchasing_power",
            "filter::gender",
            "filter::generation",
            "filter::user_status",
            "filter::user_id"
        ]
    },
    {
        name: "TARGET_AUDIENCE",
        id: 3,
        features: [
            "define",
            "manuel",
            "predefined",
            "manuel::time_range",
            "manuel::os_type",
            "manuel::profile",
            "manuel::activity",
            "manuel::gender",
            "manuel::generation",
            "manuel::app",
            "manuel::location",
            "manuel::product_analytic",
            "manuel::product_prediction"
        ]
    },
    {
        name: "OOH",
        id: 4,
        features: []
    },
    {
        name: "DMP_DSP_EXPORT",
        id: 5,
        features: [
            "ad_form",
            "google",
            "facebook",
            "meta",
            "tiktok",
            "linkedin",
            "amazon"
        ]
    },
    {
        name: "SALES_GROWTH",
        id: 6,
        features: []
    },
    {
        name: "REPORT",
        id: 7,
        features: []
    },
    {
        name: "CSV",
        id: 8,
        features: []
    },
    {
        name: "BITCOIN",
        id: 9,
        features: []
    }
];
